import React, { useContext, useEffect } from 'react'; //eslint-disable-line
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import locationStoreContext from '../stores/locationStore';
// import goTrackerConfig from 'goTrackerConfig';

import high from './../styles/img/occupancy_high.png';
import medium from './../styles/img/occupancy_med.png';
import low from './../styles/img/occupancy_low.png';
import unknown from './../styles/img/seat_icon2.png';

const TripDetail = observer(() => {
  const locationStore = useContext(locationStoreContext);
  const { t } = useTranslation();
  const trip = locationStore.trip;

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     locationStore.loadTrip(props.tripNumber);
  //   }, goTrackerConfig.autoRefreshRate || 10000);
  //   return () => clearInterval(interval);
  // });

  const getOccupancyImg = level => {
    switch (level) {
      case 'high':
        return <img src={high} alt="high"></img>;
      case 'medium':
        return <img src={medium} alt="medium"></img>;
      case 'low':
        return <img src={low} alt="low"></img>;
      default:
        return <img src={unknown} alt="unknown"></img>;
    }
  };

  const buildOccupancyStatus = consistDetails => {
    const sortedConsist = consistDetails.slice().sort((a, b) => b.consistOrder - a.consistOrder);

    return (
      <div className="equipment-container">
        {sortedConsist.map(consist => {
          return (
            <div key={consist.equipmentCode} className={`consist-equipment ${consist.occupancyThresold}`}>
              <div className={`equipment-label ${consist.occupancyThresold}`}>{consist.equipmentCode}</div>
              {/* <div className="occupancy-icon"></div> */}
              <div className="img-container">{getOccupancyImg(consist.occupancyThresold)}</div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="occupancy-container">
      <span className="occupancy-label">{t('tripDetail.occupancyLabel')}</span>
      {trip && trip.consistDetails && buildOccupancyStatus(trip.consistDetails)}
    </div>
  );
});

export default TripDetail;
